import { useState } from 'react';

/**
 * The installation's logo inside a `.wordmark` box: the same picture as the favicon, the
 * installed app and the watcher's window (`/api/meta/icon`, the Discord bot's picture or the
 * platform's own logo; the owner, 2026-10-18). The box keeps the name as its label; when the
 * picture does not load, the name is drawn instead, as the box always did.
 */
export function Wordmark({ name, small = false }: { name: string; small?: boolean }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <>{name}</>;
  return (
    <img
      className="logo"
      src={`/api/meta/icon?size=${small ? 96 : 192}`}
      alt=""
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
}
